import QueryParamsSegmentationDirective from './QueryParamsSegmentationDirective';
import QueryParamsData from './QueryParamsData';

export default angular.module('edge.platform.segmentation.queryparams', []).value('queryParamsData', QueryParamsData).directive('gwQueryParamsSegmentation', QueryParamsSegmentationDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/queryparams/module.js
// module id = 1077
// module chunks = 0